import React from 'react';
import TextField from 'material-ui/TextField';
//import Chip from 'material-ui/Chip';
import ShortForm from './ShortForm';
import Page from './Page';

export default class SignUp extends Page {

	constructor(...args){
		super(...args);
		window.app.signupForm.email = '';
		window.app.signupForm.password = '';
		window.app.signupForm.confirmPassword = '';
	}

	render(){
		return(
			<ShortForm
				label="SIGN UP"
				headerLink={{to:'/login', label:'NEED TO LOG IN?'}}
				submitButton={{label:"SIGN UP", onClick:() => { window.app.signupForm.submit()}}}
				waiting={window.app.signupForm.loading}
				errorMessage={window.app.signupForm.errorMessage}
				>
				<TextField
					label="Email"
					id="email"
					defaultValue={window.app.signupForm.email}
					onChange={ e => window.app.signupForm.email = e.currentTarget.value }
					margin="normal"
					fullWidth/>

				<TextField
					label="Password"
					type="password"
					id="password"
					defaultValue={window.app.signupForm.password}
					onChange={ e => window.app.signupForm.password = e.currentTarget.value }
					margin="normal"
					fullWidth/>

				<TextField
					label="Confirm Password"
					type="password"
					id="confirm-password"
					defaultValue={window.app.signupForm.confirmPassword}
					onChange={ e => window.app.signupForm.confirmPassword = e.currentTarget.value }
					margin="normal"
					fullWidth/>

				{/*
				<div style={{marginTop:"30px", display:'flex', flexDirection:"row", justifyContent:"center"}}>
					<Chip
						id="participant-chip"
						label="I am a Participant"
						onClick={ e => {window.app.signupForm.isResearcher = false; window.app.forceUpdate()} }
						className={!window.app.signupForm.isResearcher ? 'selected-chip' : undefined}
						/>

					<div style={{width:"50px"}}></div>

					<Chip
						id="researcher-chip"
						label={"I am a Researcher"}
						onClick={ e => {window.app.signupForm.isResearcher = true; window.app.forceUpdate()} }
						className={window.app.signupForm.isResearcher ? 'selected-chip' : undefined}
						/>
				</div>
				*/}
			</ShortForm>
		);
	}
}





// WEBPACK FOOTER //
// ./src/components/SignUp.js